export interface IBaseballMlbState {
  isShow: boolean;
  players?: Array<{
    url: string;
    name: string;
  }>;
  date?: string;
}
const initialState: IBaseballMlbState = {
  isShow: false
};
export default (state: IBaseballMlbState = initialState) => {
  return state;
};
